// Datas ficam em UTC no banco e são sempre exibidas no fuso de São Paulo.

export const FUSO = "America/Sao_Paulo";

const formatoDataHora = new Intl.DateTimeFormat("pt-BR", {
  timeZone: FUSO,
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});
const formatoData = new Intl.DateTimeFormat("pt-BR", {
  timeZone: FUSO,
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});
const formatoHora = new Intl.DateTimeFormat("pt-BR", { timeZone: FUSO, hour: "2-digit", minute: "2-digit" });

const comoData = (d: Date | string) => (typeof d === "string" ? new Date(d) : d);

/** "26/10/2026 14:05" */
export function formatarDataHora(d: Date | string): string {
  return formatoDataHora.format(comoData(d)).replace(",", "");
}

/** "26/10/2026" */
export function formatarData(d: Date | string): string {
  return formatoData.format(comoData(d));
}

/** "14:05" */
export function formatarHora(d: Date | string): string {
  return formatoHora.format(comoData(d));
}

/** "26/10/2026 14:05:09" (CSV e comprovantes). */
export function formatarDataHoraSegundos(d: Date | string): string {
  return `${formatarData(d)} ${formatoHoraSegundos.format(comoData(d))}`;
}
const formatoHoraSegundos = new Intl.DateTimeFormat("pt-BR", {
  timeZone: FUSO,
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
});

const partesSP = new Intl.DateTimeFormat("en-US", {
  timeZone: FUSO,
  hourCycle: "h23",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
});

/** Quantos ms o relógio de São Paulo está à frente do UTC naquele instante (negativo: atrás). */
function deslocamentoSP(instante: number): number {
  const p = Object.fromEntries(partesSP.formatToParts(new Date(instante)).map((x) => [x.type, x.value]));
  const comoUtc = Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), Number(p.hour), Number(p.minute), Number(p.second));
  return comoUtc - Math.floor(instante / 1000) * 1000;
}

/** "2026-10-26T08:00" no horário de São Paulo → instante UTC (vale mesmo se voltar a existir horário de verão). */
export function localSaoPauloParaUtc(texto: string): Date {
  const [dia = "", hora = "00:00"] = texto.split("T");
  const [a, m, d] = dia.split("-").map(Number);
  const [hh, mm] = hora.split(":").map(Number);
  const ingenuo = Date.UTC(a ?? 0, (m ?? 1) - 1, d ?? 1, hh ?? 0, mm ?? 0);
  let resultado = ingenuo - deslocamentoSP(ingenuo);
  const ajuste = deslocamentoSP(resultado);
  if (ajuste !== ingenuo - resultado) resultado = ingenuo - ajuste;
  return new Date(resultado);
}

/** Instante → "2026-10-26T08:00" no horário de São Paulo (valor de campo datetime-local). */
export function utcParaLocalSaoPaulo(d: Date | string): string {
  const p = Object.fromEntries(partesSP.formatToParts(comoData(d)).map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
}

/** Data sem horário ("2026-10-26", ex.: início de evento) → "26/10/2026", sem conversão de fuso. */
export function formatarDiaISO(dia: string): string {
  const [a, m, d] = dia.slice(0, 10).split("-");
  return `${d}/${m}/${a}`;
}
